// Klaviyo Back in Stock - Vertical Form Version
function initKlaviyoBIS() {
  console.log('BIS Init: Starting');

  const form = document.getElementById('klaviyo-bis-form');
  const emailInput = document.getElementById('klaviyo-bis-email');
  const submitBtn = document.querySelector('.klaviyo-bis-submit');
  const wrapper = document.querySelector('.klaviyo-bis-wrapper');

  if (!form || !submitBtn) {
    console.log('BIS Init: Missing required elements');
    return;
  }

  // Get product data from submit button
  const productData = {
    ProductName: submitBtn.dataset.productTitle,
    ProductID: submitBtn.dataset.productId,
    VariantID: submitBtn.dataset.variantId
  };

  console.log('BIS Init: Product data:', productData);

  // Handle form submission
  form.addEventListener('submit', function (e) {
    e.preventDefault();

    const email = emailInput.value.trim();
    if (!email) return;

    // Disable form and show loading state
    const originalText = submitBtn.querySelector('.button__text').textContent;
    submitBtn.disabled = true;
    emailInput.disabled = true;
    submitBtn.querySelector('.button__text').textContent = 'Subscribing...';

    console.log('BIS: Sending subscription for:', email);

    // Create the API request
    const options = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        revision: '2024-10-15'
      },
      body: JSON.stringify({
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            channels: ['EMAIL'],
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email
                }
              }
            }
          },
          relationships: {
            variant: {
              data: {
                type: 'catalog-variant',
                id: `$shopify:::$default:::${productData.VariantID}`
              }
            }
          }
        }
      })
    };

    // Send the subscription request
    fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=XiGK7A`, options)
      .then(response => {
        console.log('BIS Response:', response);

        if (response.ok) {
          // Success
          console.log('BIS: Subscription successful');

          // Hide form
          form.style.display = 'none';

          // Create success message element
          const successDiv = document.createElement('div');
          successDiv.className = 'klaviyo-bis-success-text';
          successDiv.innerHTML = `✓ You're all set!<br>We'll notify you at <strong>${email}</strong> when this item is back in stock.`;
          wrapper.appendChild(successDiv);

          // Add success class to wrapper for additional styling if needed
          wrapper.classList.add('klaviyo-bis-subscribed');
        } else {
          // Handle API errors
          return response.json().then(data => {
            console.error('BIS Error:', data);
            throw new Error(data.errors?.[0]?.detail || 'Subscription failed');
          });
        }
      })
      .catch(err => {
        console.error('BIS Network Error:', err);

        // Re-enable form
        submitBtn.disabled = false;
        emailInput.disabled = false;
        submitBtn.querySelector('.button__text').textContent = originalText;

        // Show error message below form
        const errorMsg = document.createElement('div');
        errorMsg.className = 'klaviyo-bis-error-message';
        errorMsg.textContent = 'Sorry, there was an error. Please try again.';
        form.appendChild(errorMsg);

        // Remove error message after 5 seconds
        setTimeout(() => {
          errorMsg.remove();
        }, 5000);
      });
  });
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initKlaviyoBIS);
} else {
  initKlaviyoBIS();
}
